import React, {Component, PropTypes} from 'react'
import style from './TimePicker.less'

function range(length) {
    var array = []
    for (var i = 0 ; i < length ; i++) {
        array[i] = i
    }
    return array
}

function today() {
    var date = new Date()
    date.setHours(0)
    date.setMinutes(0)
    date.setSeconds(0)
    date.setMilliseconds(0)
    return date
}

function validHours(hours, defaultHours) {
    if(isNaN(hours)) return 0
    if (hours < 24) return hours
    return defaultHours
}

function validMinutes(minutes, defaultMinutes) {
    if(isNaN(minutes)) return 0
    if (minutes < 60) return minutes
    return defaultMinutes
}

class TimePicker extends Component {
    static propTypes = {
        typing: PropTypes.bool,
        value: PropTypes.object,
        onChange: PropTypes.func.isRequired
    }

    _selectHours(event) {
        const {value, onChange} = this.props

        const previousValue = value || today()
        const hours = parseInt(event.target.value)
        const nextHours = validHours(hours, previousValue.getHours())
        const nextValue = new Date(previousValue.getFullYear(), previousValue.getMonth(), previousValue.getDate(), nextHours, previousValue.getMinutes())

        this._blancHours = isNaN(hours)
        onChange(nextValue)
    }

    _selectMinutes(event) {
        const {value, onChange} = this.props

        const previousValue = value || today()
        const minutes = parseInt(event.target.value)
        const nextMinutes = validMinutes(minutes, previousValue.getMinutes())
        const nextValue = new Date(previousValue.getFullYear(), previousValue.getMonth(), previousValue.getDate(), previousValue.getHours(), nextMinutes)
        
        this._blancMinutes = isNaN(minutes)
        onChange(nextValue)
    }    

    render() {
        const {typing, value} = this.props

        const displayHours = () => {
            if (this._blancHours) return null
            return value && value.getHours()
        }

        const displayMinutes = () => {
            if (this._blancMinutes) return null
            return value && value.getMinutes()
        }

        return (
            <div className={style.default}>
                {typing && (
                    <input
                        className='form-control'
                        placeholder='heure'
                        value={displayHours()}
                        onChange={(e) => this._selectHours(e)} />
                )}
                {!typing && (
                    <select
                        className='form-control'
                        value={displayHours() || ''}
                        onChange={(e) => this._selectHours(e)}>
                        {!value && (
                            <option value=''>heure</option>
                        )}
                        {range(24).map((v, i) => (
                            <option
                                key={i}
                                value={v}>
                                {v}
                            </option>
                        ))}
                    </select>
                )}
                <span> : </span>
                {typing && (
                    <input
                        className='form-control'
                        placeholder='minutes'
                        value={displayMinutes()}
                        onChange={(e) => this._selectMinutes(e)} />
                )}
                {!typing && (
                    <select
                        className='form-control'
                        value={displayMinutes() || ''}
                        onChange={(e) => this._selectMinutes(e)}>
                        {!value && (
                            <option value=''>minutes</option>
                        )}
                        {range(12).map((v, i) => (
                            <option
                                key={i}
                                value={v * 5}>
                                {v * 5}
                            </option>
                        ))}
                    </select>
                )}
            </div>
        )
    }
}

export default TimePicker


// WEBPACK FOOTER //
// ./lib/core/components/TimePicker.js